var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',_vm._l((_vm.ingredients),function(ingredient){return _c('li',{key:ingredient.id},[_c('IngredientItem',{attrs:{"ingredient":ingredient.ingredient,"ratio":ingredient.ratio,"showTips":false}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }